import React from "react"
import Footer from "../components/footer";

export default function DogTemplate({ pageContext: { gallery } }) {
  return (
    <div>
      <div id="content">
        <header>
          <div id="back">
            <a href="../">🡠</a>
          </div>
          <div className="gallery-header">
            <h1>{gallery.title}</h1>
            <h2>{gallery.subtitle}</h2>
            {
              gallery.description && gallery.description.length &&
              <p>{gallery.description}</p>
            }
          </div>
        </header>
        <main>
          <section className="gallery-content">
            {
              gallery.images.map(image => {
                const widthFormula = image.width === 100 ? '100%' : 'calc(' + image.width + '% - 0.75em)';
                return (
                  <div className="item" style={{width: widthFormula}}>
                    <img src={image.url} />
                  </div>
                )
              })
            }
          </section>
        </main>
      </div>
      <Footer/>
    </div>
  )
};
